import styleVars from './FolderCard.scss';

export const getPadding = (): number => {
  return 2 * parseInt(styleVars['padding'], 10);
};

export const getFooterMargin = (): number => {
  return parseInt(styleVars['footerMargin'], 10);
};
export const getFooterMarginMobile = (): number => {
  return parseInt(styleVars['footerMarginMobile'], 10);
};

export const getFooterHeight = (folderCardHeight): number => {
  return shouldShowStats(folderCardHeight)
    ? parseInt(styleVars['footerHeightWithStats'], 10)
    : parseInt(styleVars['footerHeight'], 10);
};
export const getMobileFooterHeight = (): number => {
  return parseInt(styleVars['footerHeight'], 10);
};

export const shouldShowStats = (folderCardHeight: number): boolean => {
  return folderCardHeight > 150;
};
